import AppEvent from './AppEvent';

export default class ModalEvent implements AppEvent {}


// WEBPACK FOOTER //
// ./code/foundation/events/ModalEvent.ts